import { render, staticRenderFns } from "./HomeServiceComponent.vue?vue&type=template&id=1d0a254b&scoped=true&"
import script from "./HomeServiceComponent.vue?vue&type=script&lang=js&"
export * from "./HomeServiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeServiceComponent.vue?vue&type=style&index=0&id=1d0a254b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a254b",
  null
  
)

export default component.exports